<template>
<div class="chapter">
<div class="inner_page">
<div class="otherbooks" id="adc">
<h1 class="otherbooks">ALSO BY MICHAEL FLYNN</h1>
<p class="center"><em>In the Country of the Blind</em><a id="fn1a"></a><a class="hlink" href="#/OEBPS/#fn1">*</a><br/>
<em>The Nanotech Chronicles</em><br/>
<em>Fallen Angels</em> (with Larry Niven and Jerry Pournelle)<br/>
<em>Firestar*</em><br/>
<em>The Forest of Time and Other Stories*</em><br/>
<em>Lodestar*</em><br/>
<em>Rogue Star*</em><br/>
<em>Falling Stars*</em><br/>
<em>The Wreck of the River of Stars*</em></p>
<p class="center" id="fn1"><a class="hlink" href="#/OEBPS/#fn1a">*</a> denotes a Tor book</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780765340351_epub_adc_r1.vue?65a8bb0f